export var valuesSessionStatus = ["Draft", "Active", "InvitationOnly", "Completed", "Cancelled", "Retired"];
/*

*/ 
//# sourceMappingURL=SessionStatus.js.map